import React from 'react';
import { motion } from 'framer-motion';
import { FiBox, FiShare2, FiMonitor, FiLayout, FiUserCheck, FiTarget, FiSmartphone } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const services = [
  { icon: FiBox, title: "Product Videos", desc: "Showcase your physical products in dynamic, hyper-realistic environments." },
  { icon: FiShare2, title: "Social Media Videos", desc: "Viral-ready content designed specifically for the algorithm's preferences." },
  { icon: FiTarget, title: "AI Video Ads", desc: "Data-driven advertising creative optimized for high click-through rates." },
  { icon: FiMonitor, title: "Explainer Videos", desc: "Simplify complex concepts with engaging AI-powered visual storytelling." },
  { icon: FiLayout, title: "Website-to-Video", desc: "Turn your landing pages into high-converting video presentations automatically." },
  { icon: FiUserCheck, title: "AI UGC Style Videos", desc: "Authentic-looking user-generated content without the expensive creators." },
  { icon: FiSmartphone, title: "Short-form Content", desc: "Dominate TikTok, Reels, and Shorts with consistent, high-quality output." }
];

const VideoServices = () => {
  return (
    <section className="py-24 bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-emerald-400 font-black text-sm uppercase tracking-[0.2em] mb-4">Our Expertise</h2>
          <p className="text-4xl md:text-5xl font-extrabold">Complete AI Video Solutions</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-10 bg-white/5 rounded-[2.5rem] border border-white/10 hover:bg-white/10 transition-all group"
            >
              <div className="w-16 h-16 bg-emerald-500 text-slate-950 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform">
                <SafeIcon icon={service.icon} className="text-3xl" />
              </div>
              <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
              <p className="text-slate-400 leading-relaxed font-medium">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoServices;
